import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Tariff_Floor_Interface } from 'src/app/Interface/Tariff_Floor_Interface';
import { Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TariffService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String,
    deviceTitle: String,
    dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff?token=" + Token
      + "&deviceTitle=" + deviceTitle
      + "&dsc=" + dsc).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetTarrifFloor(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetTarrifFloor?token=" + Token).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetHistoryFile(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetHistoryFile?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetHistory(Token: String, id: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetHistory?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetDeviceTariff(Token: String, id: number, CustomerId: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetDeviceTariff?token=" + Token + "&id=" + id + "&CustomerId=" + CustomerId).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetDeviceTariff_By_Tariff_Id(Token: String, id: number): Observable<Array<Tariff_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetDeviceTariff_By_Tariff_Id?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<Tariff_Interface>
      })
    )
  }

  GetSingle(Token: String, id: Number): Observable<Tariff_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Tariff/GetSingle?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )
  }

  uploadFile(body, Token: String) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Tariff/upload?token=" + Token, body).pipe(
      map(data => {
        return data
      })
    )
  }

  AddTariff(model: Tariff_Interface, Token: String): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      device_id: model.device_id,
      dsc: model.dsc,
      tariff: model.tariff,
      tariff_expert: model.tariff_expert,
      tariff_hazineh: model.tariff_hazineh,
      
      t1: model.t1,
      t2: model.t2,
      t3: model.t3,
      
      del: false,
      username: Token
    }


    return this.http.post(environment.BaseUrl + "Daro/Tariff/Add", body, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  AddTariffFloor(model: Tariff_Floor_Interface, Token: String): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    model.username = Token

    return this.http.post(environment.BaseUrl + "Daro/Tariff/AddTariffFloor", model, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  EditTariff(model: Tariff_Interface, Token: String): Observable<Tariff_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      dsc: model.dsc,
      del: false,
      username: Token
    }


    return this.http.post(environment.BaseUrl + "Daro/Tariff/Edit", body, { headers }).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

  DeleteTariff(id: number, Token: String): Observable<Tariff_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Tariff/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Tariff_Interface
      })
    )

  }

}
